const serialize = params =>
  Object.keys(params)
    .map(key => `${key}=${encodeURIComponent(params[key] || '')}`)
    .join('&');

export function getPath(url, params) {
  let result = url;
  if (params) {
    result += `?${serialize(params)}`;
  }
  return result;
}



// WEBPACK FOOTER //
// ./app/javascript/design/api/helpers.js